export const Checked = ({ width, height, viewBox, fill, styles }) => (
  <svg
    width={width || '14'}
    height={height || '11'}
    viewBox={viewBox || '0 0 14 11'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={styles}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4142 2L5 10.4142L0.585785 6L2 4.58578L5 7.58578L12 0.585785L13.4142 2Z"
      fill={fill || 'white'}
    />
  </svg>
);
